<template>
  <van-overlay :show="show" @click="cancel" :z-index="102">
    <div class="popup_box">
      <div class="popup">
        <div @click="() => cancel()" class="popup_close close_center"><span></span></div>
        <div class="popup-title">{{ $t('envelope.receiveCash') }}</div>
        <div class="amount">
          {{ reward ? formatMoney(reward.currentReward) : '--' }}
          {{ unitConversion(balance.currencyAlias) }}
        </div>
        <ShareProgress :width="5" />
        <InviteIcon :inviteIcon="inviteIcon" :onShare="onShare" />
        <div class="list-content">
          <div class="scroll" v-if="withdrawSuccess && withdrawSuccess.length > 0">
            <div v-for="(item, index) in withdrawSuccess" :key="index" class="list-new-item">
              <i class="bi bi-emoji-sunglasses" style="color: #009944"></i>
              <span class="nick-name">{{ item.nickname }}</span>
              <span class="nick-name">{{ $t('withdraw.title') }}</span>
              <span class="reward"
                >+{{ formatMoney(item.reward) }}{{ unitConversion(item.currency) }}</span
              >
            </div>
          </div>
          <div class="scroll" v-else-if="collectedList && collectedList.length > 0">
            <div class="list-title">
              <div style="width: 40%">
                {{ $t('envelope.listTitle.time') }} / {{ $t('envelope.listTitle.way') }}
              </div>
              <div>{{ $t('envelope.listTitle.help') }}</div>
            </div>
            <div class="list-item" v-for="(item, index) in collectedList" :key="index">
              <div class="list-item-content">
                <div style="width: 60%">
                  {{ dayjs(item.time).format('YYYY-MM-DD HH:mm') }}<br />{{ item.collectNickname }}
                  {{ getCollectType(item.collectType) }}
                </div>
                <div style="width: 40%; color: #27984b">
                  {{ formatMoney(item.amount) }} {{ item.currency }}
                </div>
              </div>
              <div class="list-item-line" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </van-overlay>
</template>

<script>
import { config } from '@/common/config'
import InviteIcon from '@/components/active/InviteIcon.vue'
import ShareProgress from '@/components/active/ShareProgress.vue'
import { BUS } from '@/event/EventCenter'
import { useEnvelopeStore } from '@/stores/envelope'
import { useUserStore } from '@/stores/user'
import { formatMoney, unitConversion } from '@/utils/helper'
import dayjs from 'dayjs'
import { mapActions, mapState } from 'pinia'
export default {
  name: 'LobbyActiveProgressPopup',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    cancel: {
      type: Function,
      default: () => {}
    },
    inviteIcon: {
      type: Array,
      default: () => []
    }
  },
  components: { ShareProgress, InviteIcon },
  data() {
    return {
      resBaseUrl: config.resBaseUrl,
      withdrawSuccess: [],
      collectedList: []
    }
  },
  watch: {
    reward(newValue) {
      if (newValue) {
        this.getList()
      }
    }
  },
  computed: {
    ...mapState(useEnvelopeStore, ['reward']),
    ...mapState(useUserStore, ['userInfo', 'balance', 'isLogin'])
  },
  mounted() {
    if (this.reward) {
      this.getList()
    }
  },

  methods: {
    formatMoney,
    unitConversion,
    dayjs,
    ...mapActions(useEnvelopeStore, { claimed: 'claimed', collected: 'collected' }),
    onWithdraw() {
      if (this.reward.status == 1) {
        console.log('收集中')
        this.$bus.$emit(BUS.SHOW_REWARD_POPUP, true)
      } else if (this.reward.status == 2) {
        console.log('已完成，待领取')
      }
    },
    getList() {
      if (this.reward.id > 0) {
        this.collected(this.reward.id).then((r) => {
          this.collectedList = r.records || []
          if (this.collectedList && this.collectedList.length <= 0) {
            this.claimed().then((res) => {
              console.log('claimed', res)
              this.withdrawSuccess = res.records || []
            })
          } else {
            this.withdrawSuccess = []
          }
        })
      }
    },
    getCollectType(type) {
      let result = ''
      switch (type) {
        case 1:
          result = 'SHARE'
          break
        case 2:
          result = 'REGISTER'
          break
        case 3:
          result = 'DEPOSIT'
          break
        default:
          break
      }
      return result
    }
  }
}
</script>

<style lang="scss" scoped>
.popup_box {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100%;

  .close_center {
    display: flex;
    justify-content: center;
    align-items: flex-start;
  }

  .popup_close {
    height: 0.8rem;
    width: 0.8rem;
    text-align: center;
    z-index: 2;
    margin-left: 90%;
    margin-top: -5%;
    margin-bottom: -0.8rem;

    span {
      display: inline-block;
      width: 0.6rem;
      height: 0.08rem;
      background-color: #95a5a5;
      background-image: linear-gradient(130deg, #95a5a5 0%, #95a5a5 100%);
      transform: rotate(45deg);
      margin-top: 0.355rem;
    }

    span::after {
      content: '';
      display: block;
      width: 0.6rem;
      height: 0.08rem;
      background-color: #95a5a5;
      background-image: linear-gradient(130deg, #95a5a5 0%, #95a5a5 100%);
      transform: rotate(-90deg);
    }
  }

  .popup {
    width: 5rem;
    height: auto;
    background: #f1f1f1;
    border-radius: 0.16rem 0.16rem 0.16rem 0.16rem;
    border: 0.02rem solid #95a5a5;
    padding: 0.3rem;

    .popup-title {
      width: 100%;
      height: 0.25rem;
      font-family: DroidSans;
      font-size: 0.24rem;
      color: #009944;
      line-height: 0.4rem;
      text-align: center;
      font-style: normal;
      text-transform: none;
      margin-top: 0.54rem;
    }

    .amount {
      width: 100%;
      height: 0.56rem;
      font-family: Oswald;
      font-weight: bold;
      font-size: 0.6rem;
      color: #009944;
      text-align: center;
      margin-bottom: 0.3rem;
      scale: 0.8 1;
    }

    .list-content::-webkit-scrollbar {
      width: 0;
      /* 隐藏滚动条，但保持滚动功能 */
      display: none;
    }

    .list-content {
      max-height: 4rem;
      overflow-y: scroll;
      margin-top: 0.4rem;
      width: 100%;
      -ms-overflow-style: none;
      font-size: 0.24rem;

      .scroll {
        width: 100%;
        min-height: 4rem;

        .list-title {
          display: flex;
          justify-content: space-around;
          align-items: center;
          width: 90%;
          height: 0.48rem !important;
          background: #bbc2ca;
          border-radius: 0.24rem;
          font-size: 0.24rem;
          padding-left: 0.2rem;
          padding-right: 0.2rem;
          color: #32333d;
          font-weight: bold;
        }

        .list-item {
          display: flex;
          flex-direction: column;
          width: 100%;
          margin-left: 3%;

          .list-item-content {
            display: flex;
            justify-content: space-around;
            align-items: center;
            width: 90%;
            height: 0.48rem;
            margin-top: 0.23rem;
            font-size: 0.24rem;
            padding-left: 0.2rem;
            padding-right: 0.2rem;
            color: #bcc2ca;
            font-weight: 400;
            text-align: left;
          }

          .list-item-line {
            width: 88%;
            height: 1px;
            margin-left: 3%;
            background-color: #ffffff;
          }
        }

        .list-new-item {
          display: flex;
          justify-content: space-around;
          width: 100%;
          margin-bottom: 0.25rem;

          .nick-name {
            color: #9ca0ab;
          }

          .reward {
            color: #009944;
            text-align: right;
          }
        }
      }
    }
  }
}
</style>
